// extracted by mini-css-extract-plugin
module.exports = {"phd-form":"PhdFees_phd-form__tI_3q"};